export default __webpack_public_path__ + "static/media/DesktopGifItem2.ab3308b1.gif";